export default __webpack_public_path__ + "static/media/sample-seperate-bank.0a3df278.csv";